import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import './styles/utilities.css';

// import { loadConfig } from './config';
 
// loadConfig().then(() => {
//   createRoot(document.getElementById('root')).render(
//     <React.StrictMode>
//       <App />
//     </React.StrictMode>
//   );
// });
 
createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
   </React.StrictMode>
);